export default {
  components: {
    Faqs: () => import('~/components/commom/faqs/index'),
    Team: () => import('~/components/commom/team/index'),
    FooterBlock: () => import('~/components/commom/footer/index'),
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    HowItWorks: () => import('~/components/layouts/how-it-works/index'),
    HealthInsuranceCompanies: () =>
      import('~/components/layouts/health-insurance-companies/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      companies: [],
      faqs: [
        {
          title: this.$i18n.t('What is travel insurance?'),
          content: this.$i18n.t(
            'Travel insurance is a type of insurance that provides coverage for unexpected events and expenses that may occur while you are traveling. It is designed to protect you from financial losses due to trip cancellations, medical emergencies, lost baggage, and other travel-related issues.'
          )
        },
        {
          title: this.$i18n.t('What does travel insurance typically cover?'),
          content: this.$i18n.t(
            'Travel insurance coverage can vary depending on the policy, but it often includes: Trip cancellation or interruption; Emergency medical and dental expenses; Baggage loss or delay; Trip delays; Travel accident coverage; Rental car coverage; Emergency evacuation and repatriation.'
          )
        },
        {
          title: this.$i18n.t('Do I need travel insurance?'),
          content: this.$i18n.t(
            'Whether you need travel insurance depends on your individual circumstances and the nature of your trip. It can be beneficial for international travel, expensive vacations, or trips with non-refundable components. It provides peace of mind by covering unexpected expenses and emergencies.'
          )
        },
        {
          title: this.$i18n.t('How much does travel insurance cost?'),
          content: this.$i18n.t(
            'The cost of travel insurance varies based on factors such as your age, trip duration, coverage level, and destination. You can get quotes from different insurance providers with us to compare prices.'
          )
        },
        {
          title: this.$i18n.t('When should I purchase travel insurance?'),
          content: this.$i18n.t(
            "It's advisable to purchase travel insurance as soon as you've made significant non-refundable bookings for your trip, such as flights, hotels, or tour packages. This ensures you have coverage in case you need to cancel your trip for a covered reason."
          )
        },
        {
          title: this.$i18n.t(
            'What are pre-existing medical conditions, and are they covered?'
          ),
          content: this.$i18n.t(
            "Pre-existing medical conditions are health conditions that you have before purchasing the insurance policy. Coverage for pre-existing conditions can vary between policies. Some plans offer coverage if you meet certain criteria, while others may exclude them. It's essential to read the policy details to understand how pre-existing conditions are handled."
          )
        },
        {
          title: this.$i18n.t(
            'Can I cancel my trip for any reason with travel insurance?'
          ),
          content: this.$i18n.t(
            "Some travel insurance policies offer 'cancel for any reason' coverage as an optional add-on. This coverage allows you to cancel your trip for reasons not typically covered by standard policies, but it often comes with additional costs and restrictions."
          )
        },
        {
          title: this.$i18n.t('How do I make a claim on my travel insurance?'),
          content: this.$i18n.t(
            "To make a claim, contact your insurance provider as soon as possible and follow their specific claims process. You'll likely need to provide documentation, such as receipts, medical records, and incident reports, to support your claim."
          )
        },
        {
          title: this.$i18n.t(
            'Is travel insurance the same as health insurance?'
          ),
          content: this.$i18n.t(
            'No, travel insurance and health insurance are different. Travel insurance typically covers specific travel-related incidents, while health insurance primarily covers your medical expenses within your home country or network.'
          )
        },
        {
          title: this.$i18n.t(
            'Is travel insurance mandatory for international travel?'
          ),
          content: this.$i18n.t(
            "Travel insurance is not typically mandatory for international travel, but some countries may require it for specific visa types or as a condition of entry. It's essential to check the entry requirements of your destination country. But if you are a student enrolled in the ERASMUS program, insurance is mandatory."
          )
        },
        {
          title: this.$i18n.t(
            'What information is required to perform a simulation on Kweeder.com?'
          ),
          content: this.$i18n.t(
            'In order to perform a travel insurance simulation, you need to provide your personal details and your trip details like location and its duration. Based on this information, we instantly calculate the insurance premiums tailored to your personal circumstances.'
          )
        },
        {
          title: this.$i18n.t(
            'Is it possible to obtain an insurance contract online?'
          ),
          content: this.$i18n.t(
            'Yes, it is possible to make a valid insurance contract online and/or by phone. In the same way as an in-person contract, the conclusion of a contract online or by phone requires your terms and condition acceptance as well as the confirmation from the insurance company.'
          )
        }
      ]
    }
  },
  methods: {
    sendSimulationEvent() {
      this.$gtm.pushEvent({
        event: 'health_middle'
      })
    },
    async fetchCompanies() {
      return await this.$axios.get('/companies/active', {
        params: { productType: 4 }
      })
    }
  },
  beforeMount() {
    this.fetchCompanies().then(({ data }) => {
      this.companies = Object.values(data)
    })
  }
}
